export const COMPLETED_BY_STATUS = __('Status is completed');
export const EXECUTED_BY_TCMS = __('Not Executed By TCMS Executor');